// Spec 077 — o DESVIO RELATIVO de uma métrica apurada contra o previsto, numa fonte só.
//
// Existe porque três superfícies precisavam da mesma resposta e cada uma a escreveu por conta
// própria: a fila de classificação (para eleger a métrica de maior desvio, FR-016), o painel de
// evidência da proposta (para destacá-la) e `evaluateTolerance` (para decidir `withinTolerance`).
// Três cópias de uma fórmula significam que a fila pode destacar `oee` enquanto o painel destaca
// `goodProduction` para o MESMO compromisso — e ninguém consegue dizer qual está certo.
//
// ⚠️ Previsto ZERO devolve `null`, e isso NÃO é a mesma decisão que `evaluateTolerance` toma ali.
// Aquela função cai numa comparação ABSOLUTA (`|realizado| <= faixa`), que só faz sentido porque a
// faixa está na unidade da métrica. Um PERCENTUAL relativo a zero não existe — inventá-lo (∞, ou o
// valor absoluto disfarçado de "%") faria a métrica vencer todo ranking de desvio por construção.

/**
 * `|realizado − previsto| / |previsto| × 100`, ou `null` quando não há desvio relativo definível
 * (algum lado ausente/não finito, ou previsto zero).
 */
export function deviationPct(predicted: number | null, realized: number | null): number | null {
  if (predicted === null || realized === null) return null;
  if (!Number.isFinite(predicted) || !Number.isFinite(realized)) return null;
  if (predicted === 0) return null;
  return (Math.abs(realized - predicted) / Math.abs(predicted)) * 100;
}
